import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import Anchor from '@components/icons/Anchor'

import WhatsAppLogo from '@images/whatsapp.png'
import TiktokLogo from '@images/tiktok.png'
import InstaLogo from '@images/instagram.png'

function Footer() {
  return (
    <footer className="flex flex-col items-center bg-white">
      <div className="container my-5 flex w-full items-center justify-center">
        <div className="flex w-full items-center justify-between px-4">
          <img
            src="https://cdn.mercadodeflores.pe/mercado-de-flores.png"
            alt="Logo"
            title="Mercado de Flores"
            className="w-24 md:w-32"
          />

          <div className="flex gap-2">
            {/* <Anchor
              href="https://www.facebook.com/mercadodefloresdeachoOficial"
              src="../../images/facebook.png"
              alt="Facebook"
            /> 
            */}

            <Anchor href="https://wa.link/flores" src={WhatsAppLogo} alt="Whatsapp" />

            <Anchor
              href="https://www.instagram.com/mercadodeflorespe/"
              src={InstaLogo}
              alt="Instagram"
            />

            <Anchor
              href="https://www.tiktok.com/@mercadodeflorespe"
              src={TiktokLogo}
              alt="Tiktok"
            />
          </div>
        </div>
      </div>
      <div className="flex w-full flex-wrap justify-center bg-accent py-10">
        <div className="container flex flex-col gap-4 md:flex-row md:justify-around md:gap-0 lg:pb-0">
          <div className="w-full flex-col px-4 text-center md:w-5/12 md:flex-shrink-0 md:flex-grow-0 md:text-start lg:w-1/2">
            <h3 className="mb-4 text-xl font-bold" style={{color: '#4D5656'}}>¿Quiénes somos?</h3>
            <p className="text-sm text-gray-400">
              Somos el Mercado de Flores,
              <br /> un espacio para que puedas comprar
              <br /> tus detalles, desde cualquier parte de Lima
              <br /> y enviarlo al instante.
            </p>
          </div>
          <div className="hidden w-full px-4 text-center md:flex md:flex-grow md:flex-col md:text-start">
            <h3 className="mb-4 text-xl font-bold" style={{color: '#4D5656'}}>Formas de pago</h3>
            <ul className="flex flex-col gap-2 text-sm text-gray-400">
              <li>
                <a title="Yape" href="#" className="hover:text-gray-200">
                  Yape
                </a>
              </li>
              <li>
                <a title="BCP / Interbank" href="#" className="hover:text-gray-200">
                  BCP / Interbank
                </a>
              </li>
              <li>
                <a
                  title="Tarjeta débito / crédito"
                  href="#"
                  className="hover:text-gray-200"
                >
                  Tarjeta débito / crédito
                </a>
              </li>
              <li>
                <a
                  title="Tarjeta débito / crédito"
                  href="#"
                  className="hover:text-gray-200"
                >
                  PayPal
                </a>
              </li>
            </ul>
          </div>
          <div className="w-full px-4 text-center md:flex-grow md:text-start">
            <h3 className="mb-4 text-xl font-bold" style={{color: '#4D5656'}}>Enlaces de interés</h3>
            <ul className="flex flex-col gap-2 text-sm text-gray-400">
              <li>
                <Link
                  title="Términos y condiciones"
                  to="/blog"
                  className="hover:text-gray-200"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  title="Términos y condiciones"
                  to="/terminos"
                  className="hover:text-gray-200"
                >
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link title="Privacidad" to="/privacidad" className="hover:text-gray-200">
                  Privacidad
                </Link>
              </li>
              <li>
                <Link
                  title="Libro de reclamaciones"
                  className="hover:text-gray-200"
                  to="/reclamaciones"
                >
                  Libro de reclamaciones
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mb-12 mt-8 flex h-full w-full justify-center">
        <img
          src="https://summerlove.lat/img/logo/desarrollado-por-summerlove.png"
          alt="Logo"
          title="Summer Love"
          className="w-40"
        />
      </div>
    </footer>
  )
}

export default Footer
